module.exports = "/cyber/_next/static/images/participation-rules-bg-desktop-eef226cd050c5112c298b5419af60ac3.jpg";